import React, {useEffect, useState} from 'react';
import SwiperCore, {Autoplay, Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import sliderData from '../../public/assets/slider-data.json';

SwiperCore.use([Autoplay, Navigation, Pagination]);

const Slider: React.FC = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(sliderData);
    }, []);

    return (
        <>
            <div className='container'>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={30}
                    loop={true}
                    pagination={{
                        clickable: true,
                        el: '.swiper-pagination',
                    }}
                    autoplay={{
                        delay: 100000,
                    }}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                        },
                        1200: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {data.map((item, i) => (
                        <SwiperSlide className="mb-50" key={i}>
                            <div className={`pointer card-grid-style-3 hover-up ${item.bg}`}>
                                <h3 className='text-heading-6'>{item.title}</h3>
                                <p className='text-inter-lg mt-20 color-gray-500'>{item.content}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-pagination mt-50 font-xl"></div>
                </Swiper>
            </div>
        </>
    );
};

export default Slider;
